module.exports = __webpack_public_path__ + "img/img-7.019bfa7e.png";